import { defineComponent } from "vue";
import InputWidget from "../../components/forms/InputWidget";

export default defineComponent({
    components: {
        InputWidget,
    },

    template: `
        <div class="ChatAdminPollForm">
            <button type="button" class="ChatAdminPollForm__close" @click="$emit('close')"><i class="fa fa-times" /></button>
            <div class="ChatAdminPollForm__inner">
                <InputWidget label="Pytanie">
                    <input type="text" v-model="question" />
                </InputWidget>

                <InputWidget label="Odpowiedzi">
                    <textarea v-model="answers" placeholder="każda odpowiedź w nowej linii" />
                </InputWidget>

                <div class="ChatAdminPollForm__footer">
                    <button type="button" class="button button--1" :disabled="!question?.length || !answers?.length" @click="onClickCreate">Utwórz głosowanie</button>
                </div>
            </div>
        </div>
    `,

    emits: [
        'close',
    ],

    props: {
    },

    data() {
        return {
            question: null,
            answers: null,
        };
    },

    methods: {
        async onClickCreate() {
            const answers: string[] = this.answers.split("\n").map(v => v.trim());

            await this.$root.socket.emit('poll.create', {
                question: this.question,
                answers: answers,
            });

            this.question = null;
            this.answers = null;

            this.$emit('close');
        },
    },
});
